(() => {
  // Qikify re-renders its footer after cart updates; preserve one badge per footer.
  let queued = false;
  function enhance() {
    queued = false;
    const template = document.getElementById('ks-cart-trust-template');
    if (template) document.querySelectorAll('.qsc2-drawer-footer').forEach(footer => {
      const old = footer.querySelector('.qsc2-drawer-footer__trust-badge');
      if (old) old.style.setProperty('display','none','important');
      if (!footer.querySelector('.ks-cart-trust')) {
        const anchor = old || footer.querySelector('.qsc2-checkout-button')?.parentElement;
        if (anchor) anchor.after(template.content.cloneNode(true));
      }
    });
    if (/\/pages\/faqs?\/?$/.test(location.pathname)) {
      document.querySelectorAll('.ks-page-copy:not([data-faq-ready])').forEach(copy => {
        copy.dataset.faqReady = 'true';
        [...copy.children].filter(n => n.tagName === 'P').forEach(paragraph => {
          const labels=[];
          for(const node of paragraph.childNodes){
            if(node.nodeType===3 && !node.textContent.trim())continue;
            if(node.nodeType===1 && node.tagName==='STRONG'){labels.push(node);continue;}
            break;
          }
          const label=labels.map(n=>n.textContent).join('').trim();
          if(!labels.length || !(label.includes('?') || /^Sizing\s*-$/i.test(label)))return;
          const heading=document.createElement('h3');heading.textContent=label;
          paragraph.before(heading);labels.forEach(n=>n.remove());
        });
        [...copy.children].filter(n => /^H[23]$/.test(n.tagName)).forEach(heading => {
          const details=document.createElement('details'), summary=document.createElement('summary');
          details.className='ks-faq-item'; summary.textContent=heading.textContent; details.append(summary);
          let next=heading.nextElementSibling;
          while(next && !/^H[23]$/.test(next.tagName)){const current=next;next=next.nextElementSibling;details.append(current);}
          heading.replaceWith(details);
        });
      });
    }
  }
  enhance();
  new MutationObserver(() => {if(!queued){queued=true;requestAnimationFrame(enhance);}}).observe(document.body,{subtree:true,childList:true});
})();
